import { Box } from '@mui/material';
import logoPortalSrc from '../../assets/images/logo_portal.svg';

const LogoPortal = () => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 64,
            height: 64,
            boxSizing: 'border-box',
            pt: { xs: 1, sm: 2 },
            pb: 1,
            flexShrink: 0
        }}
    >
        <img src={logoPortalSrc} alt="" style={{ maxHeight: 48, width: 'auto', display: 'block' }} />
    </Box>
);

export default LogoPortal;
